import { Box, Collapse, Divider, Stack, Typography } from '@mui/material'
import { styles } from './styles'
import type { MenuLinkProps } from './types'
import { type FC, useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded'
import { Icon } from '@/components/Icon'

export const MenuLink: FC<MenuLinkProps> = (props) => {
  const {
    title,
    icon,
    url = '',
    subLinks,
    collapse,
    setCollapse,
    access = true,
  } = props

  const location = useLocation()

  const [open, setOpen] = useState<boolean>(
    !!subLinks &&
      subLinks.some((e) => e.url && location.pathname.includes(e.url))
  )
  const [onLink, setLink] = useState<boolean>(false)

  useEffect(() => {
    setLink(
      !!subLinks &&
        subLinks.some((e) => e.url && location.pathname.includes(e.url))
    )
  }, [location])

  const openCollapse = () => {
    setOpen((prev) => (collapse ? true : !prev))
    setCollapse && setCollapse(false)
  }

  return access ? (
    <Box sx={styles.root}>
      {!title && !icon && !url && !subLinks ? (
        <Divider variant="middle" />
      ) : (
        <>
          {subLinks ? (
            <>
              <Box
                onClick={openCollapse}
                className={
                  'menu-item major-link ' + // ' sub-links '
                  `${onLink || open ? 'active' : ''}`
                }
                sx={{ userDrag: 'none' }}
              >
                <Stack direction={'row'} justifyContent={'space-between'}>
                  <Stack direction={'row'} gap={'16px'}>
                    <Box className="title-icon">
                      {icon ? (
                        <Icon section="general" size="20" name={icon} />
                      ) : null}
                    </Box>
                    <Typography sx={{ opacity: collapse ? '0' : '1' }}>
                      {title}
                    </Typography>
                  </Stack>
                  <ChevronRightRounded
                    className="collapse-icon"
                    sx={{ transform: open ? 'rotate(90deg)' : 'none' }}
                  />
                </Stack>
              </Box>
              <Collapse
                in={open && !collapse}
                className={`collapse-${open ? 'entered' : 'hidden'}`}
              >
                {subLinks.map((item, index) =>
                  item?.access !== false ? (
                    <MenuLink title={item.title} url={item.url} key={index} />
                  ) : null
                )}
              </Collapse>
            </>
          ) : url ? (
            <NavLink
              to={url}
              className={
                'menu-item ' +
                `${icon ? 'major-link ' : 'minor-link '}` +
                `${url ? '' : 'no-url'}`
              }
            >
              <Stack direction={'row'} gap={'16px'}>
                <Box className="title-icon">
                  {icon ? (
                    <Icon section="general" size="20" name={icon} />
                  ) : null}
                </Box>
                <Typography sx={{ opacity: collapse ? '0' : '1' }}>
                  {title}
                </Typography>
              </Stack>
            </NavLink>
          ) : (
            <Box
              className={
                'menu-item ' +
                `${icon ? 'major-link ' : 'minor-link '}` +
                `${url ? '' : 'no-url'}`
              }
            >
              <Stack direction={'row'} gap={'16px'}>
                <Box className="title-icon">
                  {icon ? (
                    <Icon section="general" size="20" name={icon} />
                  ) : null}
                </Box>
                <Typography sx={{ opacity: collapse ? '0' : '1' }}>
                  {title}
                </Typography>
              </Stack>
            </Box>
          )}
        </>
      )}
    </Box>
  ) : null
}
